// extracted by mini-css-extract-plugin
var _1 = "RegisterForm-module__bottom___bSwpB";
var _2 = "RegisterForm-module__center___P26Vu";
var _3 = "RegisterForm-module__form___kRy5H";
var _4 = "RegisterForm-module__subscribedContainer___JJCkq";
export { _1 as "bottom", _2 as "center", _3 as "form", _4 as "subscribedContainer" }
